import { render } from "./Edit.vue?vue&type=template&id=4bcec0e2"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Logistics/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bcec0e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bcec0e2', __exports__)) {
    console.log('reload')
    api.reload('4bcec0e2', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=4bcec0e2", () => {
    console.log('re-render')
    api.rerender('4bcec0e2', render)
  })

}


export default __exports__